import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ViewOptions from './ViewOptions';


function FloatingViewOptions(props) {

	return (
		<Card className="floatiang-card"
			style={{
				height: '36px',
				// width: '340px',
				bottom: '5px',
				position: 'absolute',
				right: '5px',
				top: '5px',
				zIndex: '1000'
			}}

		>
			<ViewOptions />
		</Card>
	)
}

export default FloatingViewOptions;


// bottom: '5px',
// left: '5px',
// position: 'absolute !important',
// right: '5px',
// top: '5px',
// zIndex: '1000'